import axiosInstance from './api';

export const createMessage = (formData) =>
  axiosInstance.post('/api/v1/chats/create_message', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then((res) => res.data);

export const listChats = (uid, page = 1, perPage = 10) => {
  console.log("listChats API called with:", { uid, page, perPage });
  const url = `/api/v1/chats/list?uid=${uid}&page=${page}&per_page=${perPage}`;
  console.log("API URL:", url);
  return axiosInstance.get(url)
    .then((res) => {
      console.log("listChats API response:", res.data);
      return res.data;
    })
    .catch((error) => {
      console.error("listChats API error:", error);
      throw error;
    });
};

export const generateAIMessage = (data) => {
  console.log("generateAIMessage API called with:", data);
  
  // Always send as JSON with proper structure
  const jsonData = {
    request_type: data.request_type || "free_chat",
    additional_data: {
      agent_id: data.additional_data?.agent_id || "agent_" + Date.now(),
      session_id: data.additional_data?.session_id || "session_" + Date.now(),
      uid: data.additional_data?.uid ,
      streaming: true,
      image_file: data.additional_data?.image_file || "",
      further_details: data.additional_data?.further_details || ""
    }
  };
  
  return axiosInstance.post('/api/v1/chats/generate_ai_message', jsonData, {
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    console.log("generateAIMessage API response:", res.data);
    return res.data;
  }).catch((error) => {
    console.error("generateAIMessage API error:", error);
    throw error;
  });
};

export const getAllChats = () => {
  console.log("getAllChats API called");
  return axiosInstance.get('/api/v1/chats')
    .then((res) => {
      console.log("getAllChats API response:", res.data);
      return res.data;
    })
    .catch((error) => {
      console.error("getAllChats API error:", error);
      throw error;
    });
};

export const updateMessageFeedback = (chatId, messageId, feedback) => {
  console.log("updateMessageFeedback API called with:", { chatId, messageId, feedback });
  
  const payload = {
    chat_id: chatId,
    message_id: messageId,
    feedback: feedback
  };
  
  return axiosInstance.patch('/api/v1/chats/update_message', payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    console.log("updateMessageFeedback API response:", res.data);
    return res.data;
  }).catch((error) => {
    console.error("updateMessageFeedback API error:", error);
    throw error;
  });
};

export const updateChatTitle = (chatId, title) => {
  
  const payload = {
    chat: {
      title: title
    }
  };
  
  return axiosInstance.patch(`/api/v1/chats/${chatId}`, payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    console.log("updateChatTitle API response:", res.data);
    return res.data;
  }).catch((error) => {
    console.error("updateChatTitle API error:", error);
    throw error;
  });
};